export const IDLE = "idle";
export const WAITING = "waiting";

export const INITCUT = "init";
export const FAILEDCUT = "failed";
export const ONCUT = "oncut";

// upoload

export const INITUPLOAD = "init-upload";
export const CHECKFAILED = "check-failed";
export const READYFORUPLOAD = "ready-for-upload";

export const ONCHECK = "upload-check";
export const ONUPLOAd = "on-upload";
export const DONEUPLOAD = "finish-upload";

// file
export const INITFILE = "init-file";
export const SUCCESSFILE = "success-file";
export const FAILEDFILE = "failed-file";
export const ONPROGRESSFILE = "progress-file";

// Files the library accepts: PDF and text documents, plus the EFB airport package (airports_<cycle>_<asof>_v<n>.sqlite.gz)
// and its SHA-256 checksum file (.sha256). react-dropzone 10 takes MIME types and extensions in one list.
export const LIBRARY_ACCEPTED_FILES =
  "application/pdf, text/plain, application/gzip, application/x-gzip, .gz, .sha256";

// Library title of an uploaded file: PDF and text files lose their 4-character extension (existing behaviour); any
// other file keeps its full name, because its extension is part of the name the app looks for ("...sqlite.gz").
export const libraryTitleOfFile = (name) =>
  /\.(pdf|txt)$/i.test(name)
    ? name.slice(0, -4).toLowerCase()
    : name.toLowerCase();
